import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { NavLink, useLocation } from "react-router-dom";
import bell from "../Images/fi_1827330.png";
import avatar from "../Images/avatar.jpg";
import settings from "../Images/fi_318477.png";
import menu from "../Images/Vector (12).png";
import location2 from "../Images/Vector-(13).webp";
import arrow from "../Images/Vector (8).png";
import HomeService from "../Services/HomeService";
import menu5 from "../Images/Vector (16).png";
import Sidebar2 from "./Sidebar2";
const Header = ({ collapse, setCollapse }) => {
  const [show, setShow] = useState(false);
  const sidebarfunc2 = () => {
    setShow(false);
  };
  const sidebarfunc = () => {
    setShow(true);
  };
  const [profileData, setProfileData] = useState([]);
  const [subscribedCities, setSubscribedCities] = useState([]);
  const location = useLocation();

  const getLoginProfile = async () => {
    const res = await HomeService.getLoginProfile();
    if (res?.status) {
      setProfileData(res.data);
      // await getSubscribedCities(res.data?._id)
    }
  };

  const getSubscribedCities = async (id) => {
    const res = await HomeService.getSubscribedCities(id);
    setSubscribedCities(res.data);
  };
  useEffect(() => {
    getLoginProfile();
  }, []);
  return (
    <div className={collapse ? "layout_collapsed" : ""}>
      <>
        {location.pathname == "/communitylist" ||
          location.pathname == "/community-fav-list" ||
          location.pathname == "/community-details" ? (
          " "
        ) : (
          <Sidebar />
        )}
        <div className="uni_wrapper"  >
          <div
            className={
              location.pathname == "/communitylist" ||
                location.pathname == "/community-fav-list" ||
                location.pathname == "/community-details"
                ? "w-100"
                : "uni_container5"
            }
          >
            <nav
              className={
                location.pathname == "/communitylist"
                  ? "nav_wrapper2 justify-content-end"
                  : "nav_wrapper justify-content-end"
              }
              style={{ position: "relative" }}
            >
              {location.pathname == "/propertylist" && (
                <button
                  className="bars_controlls_btn"
                  onClick={() => setCollapse((prev) => !prev)}
                >
                  {collapse ? (
                    <i class="fa-solid fa-arrow-right"></i>
                  ) : (
                    <i class="fa-solid fa-arrow-left"></i>
                  )}
                </button>
              )}

              <div className="admin_morning-div d-none">
                {location.pathname == "/communitylist" ? (
                  <img src={menu}></img>
                ) : (
                  ""
                )}
                <div>
                  <p className="good-morning-para">
                    Good Morning, {profileData.fullName}
                  </p>
                  {location.pathname == "/communitylist" ? (
                    ""
                  ) : location.pathname == "/propertylist" ? (
                    ""
                  ) : (
                    <p className="find-out-value-para">
                      Find out the value of your house and follow it over time
                    </p>
                  )}
                  {location.pathname == "/communitylist" ? (
                    <div className="header_location_div">
                      <img src={location2}></img>
                      <p>New Delhi</p>
                      <img src={arrow}></img>
                    </div>
                  ) : location.pathname == "/propertylist" ? (
                    <div className="header_location_div">
                      <img src={location2}></img>
                      <p>New Delhi</p>
                      <img src={arrow}></img>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="d-flex" style={{ columnGap: "20px" }}>
                <div className="nav_links-div">
                  <NavLink className={"nav-links"} to={"/"}>
                    Home
                  </NavLink>
                  <NavLink className={"nav-links"} to={"/propertylist"}>
                    Properties
                  </NavLink>
                  <NavLink className={"nav-links"} to={"/communitylist"}>
                    Community
                  </NavLink>
                  <NavLink className={"nav-links"} to={"/profile"}>
                    Profile
                  </NavLink>
                  <NavLink className={"nav-links"} to={"/aboutus"}>
                    About
                  </NavLink>
                  <NavLink className={"nav-links"} to={"/blog"}>
                    Blog
                  </NavLink>
                  <NavLink className={"nav-links"} to={"/pricingplan"}>
                    Price
                  </NavLink>
                  {/* <NavLink className={"nav-links"} to={"/cc"}>
                      Payment
                    </NavLink> */}
                  <NavLink className={"nav-links"} to={"/career"}>
                    Career
                  </NavLink>
                </div>

                <div className="bell_data_wrapper h-100">
                  {/* <div className="bell-div">
                      <img src={bell}></img>
                    </div> */}

                  <div className="admin_nav_data">
                    <div
                      className="admin_img"
                      style={{
                        borderRadius: "50%",
                        overflow: "hidden",
                        // marginRight: "10px",
                      }}
                    >
                      <img
                        src={profileData?.image || avatar}
                        alt="Admin Profile"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <NavLink
                      to="/profile"
                      style={{
                        textDecoration: "none",
                      }}
                    >
                      <div className="admin_name_div">
                        <p className="admin_name_para">
                          {profileData.fullName}
                        </p>
                        <p className="admin_email">{profileData.email}</p>
                      </div>
                    </NavLink>
                    <NavLink to="/profile">
                      <div className="settings-img">
                        <img
                          alt="settings"
                          style={{ width: "16px" }}
                          src={settings}
                        ></img>
                      </div>
                    </NavLink>
                  </div>
                </div>
                <div id="menu_bar_new">
                  <div onClick={sidebarfunc} className="menu_bar_wrapper_div">
                    <img src={menu5} />
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
        {show && <Sidebar2 sidebarfunc2={sidebarfunc2} />}
      </>
    </div>
  );
};

export default Header;
